/**
 * Partes de texto VR: texto plano + enlaces http(s) clicables (sin HTML crudo).
 */
export function splitSpiritualBodyLinks(raw) {
  const text = String(raw || '');
  const parts = [];
  const re = /https?:\/\/[^\s<>"'`]+/gi;
  let last = 0;
  let m;
  while ((m = re.exec(text))) {
    if (m.index > last) {
      parts.push({ type: 'text', value: text.slice(last, m.index) });
    }
    let href = m[0];
    let trail = '';
    const trimmed = href.replace(/[),.;!?]+$/g, (s) => {
      trail = s;
      return '';
    });
    href = trimmed;
    try {
      const parsed = new URL(href);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
        parts.push({ type: 'link', href, label: href });
      } else {
        parts.push({ type: 'text', value: m[0] });
        trail = '';
      }
    } catch {
      parts.push({ type: 'text', value: m[0] });
      trail = '';
    }
    if (trail) parts.push({ type: 'text', value: trail });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ type: 'text', value: text.slice(last) });
  if (!parts.length && text) parts.push({ type: 'text', value: text });
  return parts;
}
